import type { ItemRenderer } from "./types";

export const renderBracket: ItemRenderer = ({ svg, bboxPx }) => {
    const color = "#a64022";

    const stroke = 0.45;

    const xL = bboxPx.x + stroke / 2;
    const xR = bboxPx.x + bboxPx.w - stroke / 2;
    const yT = bboxPx.y + stroke / 2;
    const yB = bboxPx.y + bboxPx.h - stroke / 2;

    const safeW = Math.max(0, xR - xL);
    const safeH = Math.max(0, yB - yT);
    if (safeW <= 0 || safeH <= 0) return;

    svg.line(xL, bboxPx.y, xL, bboxPx.y + bboxPx.h).stroke({ width: stroke, color, linecap: "butt" });

    svg.line(xR, bboxPx.y, xR, bboxPx.y + bboxPx.h).stroke({ width: stroke, color, linecap: "butt" });

    const shelfHraw = Math.max(2, bboxPx.h * 0.18);
    const shelfH = Math.min(shelfHraw, safeH);

    svg.rect(safeW, shelfH)
        .move(xL, yB - shelfH)
        .fill("#fff")
        .stroke({ width: stroke, color });
};
